module.exports = __webpack_public_path__ + "static/media/Mercedes-Benz-PNG-File.aa1e7230.png";